"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks Blockchain API
 * Welcome to the API reference overview for the <a href=\"https://docs.hiro.so/get-started/stacks-blockchain-api\">Stacks Blockchain API</a>.  <a href=\"https://hirosystems.github.io/stacks-blockchain-api/collection.json\" download=\"stacks-api-collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: STACKS_API_VERSION
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressNftListResponseToJSON = exports.AddressNftListResponseFromJSONTyped = exports.AddressNftListResponseFromJSON = void 0;
const _1 = require("./");
function AddressNftListResponseFromJSON(json) {
    return AddressNftListResponseFromJSONTyped(json, false);
}
exports.AddressNftListResponseFromJSON = AddressNftListResponseFromJSON;
function AddressNftListResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'limit': json['limit'],
        'offset': json['offset'],
        'total': json['total'],
        'nft_events': (json['nft_events'].map(_1.NftEventFromJSON)),
    };
}
exports.AddressNftListResponseFromJSONTyped = AddressNftListResponseFromJSONTyped;
function AddressNftListResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'limit': value.limit,
        'offset': value.offset,
        'total': value.total,
        'nft_events': (value.nft_events.map(_1.NftEventToJSON)),
    };
}
exports.AddressNftListResponseToJSON = AddressNftListResponseToJSON;
//# sourceMappingURL=AddressNftListResponse.js.map